export default "__VITE_ASSET__D5CUgcY0__"